import { Component, EventEmitter, Output, Input} from '@angular/core';

/**
   * Logger Factory
   * @namespace value: value of input to bring to parent
*/

@Component({
  selector: 'ute-rename-modal',
  templateUrl: 'ute-rename-modal.component.html'
})
export class UteRenameModalComponent  {
  @Input() title: String;
  @Input() initialValue: string;
  @Output() actionValue = new EventEmitter;
  public nameGroup: string;

  constructor() {
    
  }
   
  ngOnInit() {
    if(this.initialValue && this.initialValue.length){
      this.nameGroup = this.initialValue;
    }
  }

  rename(){
    this.actionValue.emit(this.nameGroup);
  }
  cancel(){
    this.actionValue.emit('');
  }

 
}


// WEBPACK FOOTER //
// ./src/app/components/commons/molecules/ute-rename-modal/ute-rename-modal.component.ts